/**
 * Example Categories Data
 *
 * Примеры категорий с мультиязычными названиями (en, fr)
 * Эти данные соответствуют новой структуре CategoryCardProps
 *
 * В реальном приложении эти данные приходят из API/БД
 */

import type { CategoryCardProps } from '../../types';
import type { Category } from '@hummii/shared-types';

/**
 * Helper function to create example Category object
 */
const createExampleCategory = (
  id: string,
  nameEn: string,
  nameFr: string,
  iconUrl: string
): Category => ({
  id,
  slug: nameEn.toLowerCase().replace(/\s+/g, '-'),
  nameEn,
  nameFr,
  descriptionEn: null,
  descriptionFr: null,
  icon: null,
  iconUrl,
  parentId: null,
  isActive: true,
  isPopular: false,
  sortOrder: parseInt(id),
  createdAt: new Date(),
  updatedAt: new Date(),
});

/**
 * Example category 1: Construction & Renovation
 */
export const constructionCategoryExample: CategoryCardProps = {
  category: createExampleCategory(
    '1',
    'Construction & Renovation',
    'Construction et Rénovation',
    '/images/categories/construction.jpg'
  ),
};

/**
 * Example category 2: Cleaning & Organization
 */
export const cleaningCategoryExample: CategoryCardProps = {
  category: createExampleCategory(
    '2',
    'Cleaning & Organization',
    'Nettoyage et Organisation',
    '/images/categories/cleaning.jpg'
  ),
};

/**
 * Example category 3: Courier & Moving
 */
export const courierCategoryExample: CategoryCardProps = {
  category: createExampleCategory(
    '3',
    'Courier & Moving Services',
    'Services de Coursier et Déménagement',
    '/images/categories/courier.jpg'
  ),
};

/**
 * Example category 4: Home Assistance
 */
export const homeAssistanceCategoryExample: CategoryCardProps = {
  category: createExampleCategory(
    '4',
    'Home Assistance',
    'Aide à Domicile',
    '/images/categories/home.jpg'
  ),
};

/**
 * Example category 5: Family & Kids
 */
export const familyKidsCategoryExample: CategoryCardProps = {
  category: createExampleCategory(
    '5',
    'Family & Kids Services',
    'Services pour Familles et Enfants',
    '/images/categories/family.jpg'
  ),
};

/**
 * Example category 6: Beauty & Personal Care
 */
export const beautyCategoryExample: CategoryCardProps = {
  category: createExampleCategory(
    '6',
    'Beauty & Personal Care',
    'Beauté et Soins Personnels',
    '/images/categories/beauty.jpg'
  ),
};

/**
 * Example category 7: Photo & Video
 */
export const photoCategoryExample: CategoryCardProps = {
  category: createExampleCategory(
    '7',
    'Photo & Video Services',
    'Services Photo et Vidéo',
    '/images/categories/photo.jpg'
  ),
};

/**
 * Example category 8: Automotive
 */
export const autoCategoryExample: CategoryCardProps = {
  category: createExampleCategory(
    '8',
    'Automotive Services',
    'Services Automobiles',
    '/images/categories/auto.jpg'
  ),
};

/**
 * All example categories
 */
export const exampleCategories: CategoryCardProps[] = [
  constructionCategoryExample,
  cleaningCategoryExample,
  courierCategoryExample,
  homeAssistanceCategoryExample,
  familyKidsCategoryExample,
  beautyCategoryExample,
  photoCategoryExample,
  autoCategoryExample,
];
